import {
  getFirestore,
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
  setDoc,
  writeBatch,
} from "firebase/firestore";
import app from "./config";
import { TimeTablePeriod, UpdateType } from "../../models/time_table_period";
const db = getFirestore();



export const getTimeTableForSchool = async (schoolId) => {
  try {
    const q = query(
      collection(db, "schools", schoolId, "time_tables"),
      where("periodType", "!=", null)
    );
    const querySnapshot = await getDocs(q);
    if (querySnapshot.size > 0) {
      const periods = querySnapshot.docs.map((doc) => {
        let data = {
          id: doc.id,
          ...doc.data(),
        };
        if (!data.dayName) {
          console.log(
            `No dayName for the period: ${data.id} dayCode: ${data.dayCode} TYPE ${data.periodType}`
          );
        }
        const period = TimeTablePeriod.fromJSON(data);
        return period;
      });

      return periods;
    } else {
      throw new Error("No such document exists!");
    }
  } catch (error) {
    console.error("Error getting time table for school:", error);
    throw error;
  }
};

export const saveTimeTable = async (schoolId, timeTableData, deleteDataList = []) => {
  try {
    let batch = writeBatch(db);
    let batchCount = 0;
    
    // First, handle updates and inserts for periods with updateRequired = true (excluding deletes)
    for (const period of timeTableData) {
      if (period.updateRequired) {
        let docRef;
        if(period.updateType == UpdateType.ADD || period.isLocal){
          // Create a new document and get the ID for ADD operations
          docRef = doc(collection(db, "schools", schoolId, "time_tables"));
          console.log(`ID for new period: ${docRef.id}`);
          console.log(period.toJSON());
          period.id = docRef.id;
        }else{
          docRef = doc(db, "schools", schoolId, "time_tables", period.id);
        }
        batch.set(docRef, period.toJSON());
        
        batchCount++;
        
        // If batch count reaches 500, commit and start a new batch
        if (batchCount === 500) {
          await batch.commit();
          batch = writeBatch(db);
          batchCount = 0;
        }
      }
    }
    
    // Commit any remaining operations in the current batch
    if (batchCount > 0) {
      await batch.commit();
      batch = writeBatch(db);
      batchCount = 0;
    }
    
    // Then, handle deletions from deleteDataList if it's not empty
    if (deleteDataList.length > 0) {
      for (const period of deleteDataList) {
        if(period.isLocal){
          continue;
        }
        const docRef = doc(db, "schools", schoolId, "time_tables", period.id);
        batch.delete(docRef);
        
        batchCount++;
        
        // If batch count reaches 500, commit and start a new batch
        if (batchCount === 500) {
          await batch.commit();
          batch = writeBatch(db);
          batchCount = 0;
        }
      }
      
      // Commit any remaining delete operations
      if (batchCount > 0) {
        await batch.commit();
      }
    }
  } catch (error) {
    console.error("Error saving time table:", error);
    throw error;
  }
};
